<template>
    <div id="" class="pb-3 mb-3 scroll-height">
        <div class="main-content sub subcontent mb-3">
            <div id="recaptchaContainer"></div>
            <div class="content-header p-0">
                <div class="w-100 mx-0">
                    <h1>{{ 'Metadata Info Of Your File' | trans }}</h1>
                    <h2 class="text-left">
                        {{ 'The following table contains all the exif data and metadata info we could extract from your file using our free online metadata and exif viewer.' | trans }}
                    </h2>
                </div>
            </div>
        </div>

      <div class="alert alert-info d-flex flex-column metainfo">
        <p>{{ 'The data shown is all the metadata we could automatically extract from your file.' | trans }}</p>
        <p>{{ 'It may be neither complete nor adequate.' | trans }}</p>
        <p>{{ 'Metadata could have been changed or deleted in the past. Please be aware that the metadata is provided without liability.' | trans }}</p>
      </div>

        <div v-if="showOutput" class="">
            <div v-for="(outerValue, outerKey) in output" class="py-3 px-3 bg-white border br-8 mb-3">
                <div v-for="(value, key) in outerValue" class="border-bottom">
                    <template v-if="Array.isArray(value) || isObjectOfObjects(value)">
                        <ViewArrayElement :data-set="value" :parent-key="key"></ViewArrayElement>
                    </template>
                    <template v-else>
                        <ViewJsonSingleElement :data-set="value" :parent-key="key"></ViewJsonSingleElement>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
import ViewJsonSingleElement from './ViewJsonSingleElement.vue';
import ViewArrayElement from './ViewArrayElement.vue';
import store from "../../../mixins/store.mixin";
import currentJob from "../../../mixins/current_job.mixin";

export default {
    name: 'ViewJson',
    components: {
        ViewArrayElement,
        ViewJsonSingleElement,
    },
  mixins: [
    store,
    currentJob
  ],
    data() {
        return {
            status: 'No Status',
            output: {},
            showOutput: false,
        };
    },
    mounted: function () {
        this.getJson(this.currentOutput.uri);
    },
    methods: {
        getJson(url) {
            axios.get(url).then((response) => {
                this.output = response.data;
                this.showOutput = true;
            });
        },
        isObjectOfObjects(value) {
            return typeof value === 'object' && !value.key_formatted;
        },
    },
};
</script>
<style>
.metainfo {
  gap: 5px;
  p {
    padding:0;
    margin: 0;
  }
}
.scroll-height {
    height: calc(100vh - 80px);
}
</style>
